import React from 'react';
import { IconProps } from './types';

const MinusIcon = ({ className }: IconProps): React.ReactElement => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8.5V7h12v1.5z" />
  </svg>
);

export default MinusIcon;
